export default "__VITE_ASSET__00d487c1__"